import { useRef } from 'react'
import { Tooltip } from 'bootstrap'
import { useEffect, useState } from 'react'

export function useTooltip(
  ref: React.RefObject<HTMLElement>,
  options: Partial<Tooltip.Options>,
  dependencies: unknown[]
) {
  const [tooltip, setTooltip] = useState<Tooltip | null>(null)

  const optionsRef = useRef(options)

  // biome-ignore lint/correctness/useExhaustiveDependencies: should be correct behaviour
  useEffect(() => {
    optionsRef.current = options
    const element = ref.current
    if (element) {
      setTooltip(new Tooltip(element as HTMLElement, optionsRef.current))
    }
    return () => {
      if (element) {
        Tooltip.getInstance(element as HTMLElement)?.dispose()
        setTooltip(null)
      }
    }
  }, [ref, ...dependencies])

  return tooltip
}
